export default __webpack_public_path__ + "static/media/lp_tou4.75852fd9.png";